var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "vgp-interactive-element",
    style: { width: _vm.width + "px" },
    attrs: { id: "inputRangeSlider" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }